import React, { useReducer, useContext } from "react";
import { inviteMembersReducer as reducer } from "../reducers/inviteMembersReducer";
import { inviteMembersActions as actions } from "../actions/inviteMembersActions";

const initialValue = {
  enterpriseId: null,
  members: null,
  selectedMemberIds: [],
};

const inviteMembersContext = React.createContext();

const InviteMembersContext = ({ enterpriseId, children }) => {
  initialValue.enterpriseId = enterpriseId;

  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <inviteMembersContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </inviteMembersContext.Provider>
  );
};

export const useInviteMembersContext = () =>
  React.useContext(inviteMembersContext);
export default InviteMembersContext;
